import { FC, useEffect } from "react";

import { type Invoice } from "../../../types/InvoiceTypes";
import { formatAmount } from "../../../utils/numbers/money";
import { toastWarning } from "../../../utils/toasts";
import { useInvoiceCurrencies } from "../../../hooks/useInvoiceCurrencies";

type Props = {
  data: Invoice;
};

export const InvoiceTotal: FC<Props> = ({ data }) => {
  const invoiceCurrencies = useInvoiceCurrencies(data);
  const total = data.amount || 0;

  useEffect(() => {
    if (total > 999999) {
      toastWarning("Max total is 999 999");
    }
  }, [total]);

  return (
    <div className="flex flex-row border-t border-gray-50 pt-6 mb-6 justify-between items-center">
      <div className="theme-text text-3xl">Total</div>

      <div className="theme-special-text text-4xl leading-[54px]">
        {formatAmount(total || 0)}{" "}
        <span className="uppercase">
          {invoiceCurrencies?.incoming?.symbol || ""}
        </span>
      </div>
    </div>
  );
};
